// 单文件引入方式

import Placeholder from './ZuiPlaceholder.vue'

export default {
  install(Vue) {
    Vue.component('ZuiPlaceholder', Placeholder)
  }
}

export { Placeholder }
